<div id="uxMessageLabel" *ngIf="haserror">
    <div class="row">
        <div class="col-24">
            <p class="bottom-20"><strong>Note:</strong> Your access to Electronic Application is temporarily denied for the following reason(s):</p>
            <!--<p *ngIf="trainingMsg" class="bottom-10">You have not completed the {{planYear}} certification training course. To access Electronic Application, you must first complete the <a class="link" (click)="GetTrainingURL()" class="link-button" target='_blank'>Online Training  </a>.</p>-->
            <p *ngIf="trainingMsg" class="bottom-10">
                You have not completed the necessary certification training course.<br />
                For additional information on training, please visit the <a (click)="GetTrainingURL()">Training and Certification</a> page.
            </p>
            <p *ngIf="backgroundMsg" class="bottom-10">Please note that you will not be be able to access this page further until SilverScript completes processing your background check.</p>
            <p *ngIf="trainingFailedMsg" class="bottom-20">You have failed the {{planYear}} certification training course.</p>
            <p *ngIf="licencemsg" class="bottom-20">You do not have a valid state license.</p>
        </div>
    </div>
</div>
<div role="alert">
    <div class="loading-spinner" *ngIf="loading">
        <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
        <div class="spinner">
            <div></div>
            <div></div>
        </div>
        <div class="loading-text">Loading..</div>
    </div>
</div>
<div class="enroll-eapp" *ngIf="validAgent">
    <div class="row">
        <div class="col-16">
            <div class="both-at-end">
                <h1>Electronic Application</h1>
                <button class="button primary" (click)="viewHistory()" tabindex="0">
                    eApplication History
                </button>

            </div>
        </div>
    </div>

    <button #focusableEleTop class="focusable-element"></button>
    <form (keydown)="onKeyDown($event)">
        <div class="row" *ngIf="hasError">
            <div class="col-24">
                <div class="alert danger">
                    <p><em>Error Message:</em></p>
                    <ul>
                        <li *ngFor="let error of ErrorMessages"><button [innerHtml]="error"></button></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <p class="required">All fields are required, unless marked as optional.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <h2 class="head2-small">Section 1: Tell us about the applicant</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <div class="bottom-20">
                    <ElectionPeriod electperiodchild
                                    [reasonCode]="reasonCode"
                                    [periodSelected]="periodSelected"
                                    (periodSelectdChanged)="periodSelectdChanged($event)"
                                    (reasonCodeChanged)="reasonCodeChanged($event)"
                                    (hasDateField)="hasDateField($event)"
                                    (sepDateChange)="sepdatechange($event)">
                    </ElectionPeriod>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <h2 class="head2-small">Section 2: To Enroll in {{insuranceCompany}} Prescription Drug Plan</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <drugplan [enrollmentDrugViewModel]="enrollmentViewModel" [disableAppRecievDt]="disableAppRecievDt" [AgentOrgID]="AGENTORGID"></drugplan>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <h2 class="head2-small">Section 3: Beneficiary Information</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <div class="bottom-20">
                    <beneficiary-info [disabled]="disabled"
                                      [enrollment]="enrollmentViewModel.beneficiaryInfo"
                                      (onValueChange)="this.change($event)">
                    </beneficiary-info>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="bottom-20">
                    <label>{{emailLabel}}</label>
                    <ValidatedTextField [text]="enrollmentViewModel.APPEMAIL" [maxlength]="40"
                                        (onValueChange)="emailChanged($event)">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <!--<div class="row">
        <div class="col-24">
            <eob (onEobOptionChange)="this.eobOptionChanged($event)" [EOBEmaildisabled]="EOBEmaildisabled"
                 (onEmailChange)="this.emailChanged($event)" [email]="enrollmentViewModel.APPEMAIL" [eobOption]="enrollmentViewModel.EOB"></eob>
        </div>
    </div>-->
        <div class="row">
            <div class="col-16">
                <p><strong>Paperless Settings</strong></p>
            </div>
            <div class="col-16">
                <p>
                    Would you like to receive paperless Explanation of Benefit (EOB) statements?
                </p>
                <div class="row">
                    <br />
                </div>
                <p>
                    We'll send you a monthly email letting you know how to access and view your secure EOB statement. You will need to provide us with your email address. You can opt out at any time.
                </p>
            </div>
        </div>
        <div class="row">
            <br />
        </div>
        <div class="row">
            <div class="col-16">
                <div class="bottom-20">
                    <ValidatedCheckbox [id]="'EOBoption'"
                                       [label]="'Yes, I want to receive my EOB statements electronically.'"
                                       [checked]="isEOB"
                                       (onValueChange)="eobOptionChanged($event)">
                    </ValidatedCheckbox>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-16">
                <div class="bottom-20">
                    <p>
                        Visit the online preference center at <a class="link" href="https://www.aetnamedicare.com" target="_blank">aetnamedicare.com</a> once you complete your registration by clicking Login and following the steps for register. See exactly what's available for you to receive digitally and manage your document delivery preferences between digital and mailed. You may go back to paper at any time. Please note that some documents may take up to two months to switch to digital delivery. Thank you for going paperless!
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="bottom-20">
                    <label>{{emailLabel}}</label>
                    <ValidatedTextField [text]="enrollmentViewModel.APPEMAIL" [maxlength]="40"
                                        [validators]="[]"
                                        [disabled]="true">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <div class="bottom-20">
                    <p>
                        We will use your email address to keep you up to date on your SilverScript plan.
                        You can opt out any time.
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <div class="bottom-20">
                    <DualAddress [topAddress]="residentialAddress"
                                 [bottomAddress]="mailingAddress"
                                 [topAddressName]="'Permanent Address/Long Term Care Address'"
                                 [bottomAddressName]="'Mailing Address'"
                                 [LTCFacilityName]="enrollmentViewModel.LTCFACILITY"
                                 [LTCFacilityPhone]="enrollmentViewModel.LTCPHONE"
                                 [states]="states"
                                 [disabled]="disabled"
                                 (onTopAddressChange)="residentialAddressChanged($event)"
                                 (onBottomAddressChange)="mailingAddressChanged($event)"
                                 (onLTCFacilityNameChange)="enrollmentViewModel.LTCFACILITY=$event"
                                 (onLTCFacilltyPhoneChange)="enrollmentViewModel.LTCPHONE=$event">
                    </DualAddress>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-24">
                <h2 class="head2-small">Section 4: Paying Your Plan Premium</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-24">

                <payment-method id="payment-method"
                                (onPaymentOptionChange)="this.paymentOptionChanged($event)"
                                (onPaymentAccountChange)="this.paymentAccountChanged($event)"
                                [paymentOption]="this.paymentOption"
                                [paymentAccount]="this.paymentAccount">
                </payment-method>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <h2 class="head2-small">Section 5: Please Read and Answer These Important Questions</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <prescripitionDrug [enrollment]="enrollmentViewModel" [showOtherCoverage]="showOtherCoverage"
                                   (onValueChange)="onPrescriptionDrugValueChange($event)"></prescripitionDrug>
            </div>
        </div>
        <div class="row" style="clear:left; display:flex;">
            <div class="col-24"> 
                <accessibility [accessibilityValue]="accessibilityValue" [enrollment]="enrollmentViewModel"></accessibility>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <h2 class="head2-small">Section 6: Please Read This Important Information</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <notes [enrollment]="enrollmentViewModel"></notes>
            </div>
        </div>
        <div class="row">
            <div *ngIf="!disabled">
                <div class="col-24">
                    <button id="continueEAP" class="button primary" (click)="submitForm()">Continue</button>
                </div>
            </div>
            <div *ngIf="disabled">
                <button id="continueEAP" class="button primary" (click)="continueStep()">Everything looks good, continue</button>
                <button id="continueEAP" class="button primary" (click)="correctionStep()">Something is wrong. Please inform my agent that a correction is needed.</button>
                <button id="continueEAP" class="button primary" (click)="rejectStep()">I've changed my mind. Reject and cancel this application process.</button>
            </div>
        </div>
    </form>
</div>

<EAppInformation *ngIf="PopUpShow" (notify)="onNotify($event)"></EAppInformation>
